import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import styles from './ArticleTitlePrice.module.css';

const ArticleTitlePrice = () => {
  const { articleTitlePrice } = useSearchParamOrDefaultProps();

  const priceLength = articleTitlePrice?.length;
  const firstHalf = articleTitlePrice?.substr(0, priceLength - 2);
  const backHalf = articleTitlePrice?.substr(priceLength - 2);

  return (
    <article className={styles.articleTitlePriceWrapper}>
      <div className={styles.articleTitlePrice}>
        ${firstHalf}
        <sup className={styles.articleTitlePriceCustomCents}>{backHalf}</sup>
      </div>
    </article>
  );
};

ArticleTitlePrice.displayName = 'ArticleTitlePrice';

export default ArticleTitlePrice;
